__turbopack_context__.v({
  "checkmark": "CurrencySelector-module__9totfG__checkmark",
  "closeButton": "CurrencySelector-module__9totfG__closeButton",
  "currencyButton": "CurrencySelector-module__9totfG__currencyButton",
  "currencyCode": "CurrencySelector-module__9totfG__currencyCode",
  "currencyInfo": "CurrencySelector-module__9totfG__currencyInfo",
  "currencyLabel": "CurrencySelector-module__9totfG__currencyLabel",
  "currencyList": "CurrencySelector-module__9totfG__currencyList",
  "currencyOption": "CurrencySelector-module__9totfG__currencyOption",
  "currencySymbolBadge": "CurrencySelector-module__9totfG__currencySymbolBadge",
  "currencyWrapper": "CurrencySelector-module__9totfG__currencyWrapper",
  "disabled": "CurrencySelector-module__9totfG__disabled",
  "expandIcon": "CurrencySelector-module__9totfG__expandIcon",
  "fadeIn": "CurrencySelector-module__9totfG__fadeIn",
  "full": "CurrencySelector-module__9totfG__full",
  "labelFull": "CurrencySelector-module__9totfG__labelFull",
  "labelShort": "CurrencySelector-module__9totfG__labelShort",
  "modal": "CurrencySelector-module__9totfG__modal",
  "modalHeader": "CurrencySelector-module__9totfG__modalHeader",
  "modalTitle": "CurrencySelector-module__9totfG__modalTitle",
  "overlay": "CurrencySelector-module__9totfG__overlay",
  "selected": "CurrencySelector-module__9totfG__selected",
  "selectedCode": "CurrencySelector-module__9totfG__selectedCode",
  "selectedSymbol": "CurrencySelector-module__9totfG__selectedSymbol",
  "slideUp": "CurrencySelector-module__9totfG__slideUp",
  "slideUpMobile": "CurrencySelector-module__9totfG__slideUpMobile",
  "symbolText": "CurrencySelector-module__9totfG__symbolText",
});
